(function () {
  const STORAGE_KEY = 'nx_cart_reserve_expiry';
  let intervalId = null;

  // Convert MM:SS string into milliseconds
  function parseTime(str) {
    if (!str) return null;
    const parts = str.split(':');
    if (parts.length !== 2) return null;

    const minutes = parseInt(parts[0], 10);
    const seconds = parseInt(parts[1], 10);

    if (isNaN(minutes) || isNaN(seconds)) return null;
    return (minutes * 60 + seconds) * 1000;
  }

  // Clear cart and refresh the cart drawer without reloading the page
  function clearCartAndReset(display, clearOnZero) {
    // Remove stored expiry so timer can restart next time
    localStorage.removeItem(STORAGE_KEY);

    // If clearing cart is disabled, just stop the timer
    if (!clearOnZero) {
      if (display) display.textContent = '00:00';
      return;
    }

    // Clear the Shopify cart
    fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        if (display) display.textContent = '00:00';

        // Fetch the updated empty cart
        return fetch('/cart.js', {
          headers: { 'Accept': 'application/json' }
        });
      })
      .then(res => res.json())
      .then(cart => {
        // Dispatch cart:refresh event with fresh cart data
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: {
              cart: cart,
              openMiniCart: true
            }
          })
        );
      })
      .catch(err => console.error('Error clearing cart:', err));
  }

  // Initialize or re-initialize the cart reservation timer
  window.initCartReserveTimer = function () {
    // Target only the cart drawer timer
    const wrapper = document.querySelector('cart-drawer [data-cart-timer-wrapper]');
    if (!wrapper) return;

    const display = wrapper.querySelector('#cart-timer-display');
    if (!display) return;

    // Read initial time from data attribute
    const initialTimeString = (wrapper.getAttribute('data-cart-timer')).trim();
    const durationMs = parseTime(initialTimeString);
    if (!durationMs) return;

    // Read "clear cart on zero" setting
    const clearAttr = wrapper.getAttribute('data-cart-clear-on-zero');
    const clearOnZero = clearAttr === 'true' || clearAttr === '1';

    const now = Date.now();
    let expiry = localStorage.getItem(STORAGE_KEY);

    // Start a new timer if none exists or if it already expired
    if (!expiry || Number(expiry) <= now) {
      expiry = now + durationMs;
      localStorage.setItem(STORAGE_KEY, String(expiry));
    } else {
      expiry = Number(expiry);
    }

    // Clear any existing interval (important after drawer re-render)
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }

    // Update countdown every second
    function update() {
      const diff = expiry - Date.now();

      // Timer reached zero
      if (diff <= 0) {
        clearInterval(intervalId);
        intervalId = null;
        display.textContent = '00:00';
        clearCartAndReset(display, clearOnZero);
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      display.textContent =
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0');
    }

    update();
    intervalId = setInterval(update, 1000);
  };

  // Initialize timer on first page load
  document.addEventListener('DOMContentLoaded', function () {
    window.initCartReserveTimer();
  });
})();
